import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import css from './Level14CellCenter.module.css';
import markerCss from "../Marker.module.css";
import {minZoomForLevel17} from "../../../utils/s2";


const Level14CellCenter = (props) => {
	if( props.zoom > minZoomForLevel17 )
		return null;

	const numPortals = [...Object.values(props.gyms), ...Object.values(props.stops)].filter(portal => portal['s2-14'] === props.keyName).length;
	const breakpoints = [2, 6, 20, 'max'];
	let nextBreakpoint = 2;
	for( let i=0; i<4; i++ )
		if( breakpoints[i] <= numPortals )
			nextBreakpoint = breakpoints[i+1];

	const classes = [markerCss.Marker, css.Level14Marker];
	if( numPortals && numPortals+1 === nextBreakpoint )
		classes.push(css.NeedsOneMore);
	else if( numPortals && numPortals+2 === nextBreakpoint )
		classes.push(css.NeedsTwoMore);
	else if( numPortals === 0 )
		classes.push(css.Empty);

	return (<div className={classes.join(' ')}>
		{numPortals} / {nextBreakpoint}
	</div>);
};

Level14CellCenter.propTypes = {
	keyName: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
	return {
		zoom: state.map.zoom,
		gyms: state.marker.gyms,
		stops: state.marker.stops,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: (value) => dispatch(FN(value)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Level14CellCenter);